import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconCapitalLetterK = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M15.336 16.4004H13.692L10.38 12.4044V16.4004H9V8.00037H10.38V11.7684L13.572 8.00037H15.216L11.82 12.0924L15.336 16.4004Z" }),
});

export { IconCapitalLetterK };
